import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function RefundButton({ row }) {
  const navigate = useNavigate();

  function handleRefundButtonClick() {
    navigate('refund', {
      state: {
        bookingId: row.id,
        childName: row.displayNameRomanized,
        serviceTypeDescription: row.serviceType
      }
    });
  }

  const isRefunded = row.refunded;
  const isEligibleForRefund = row.eligibleForRefund;

  const buttonText = isRefunded ? 'Refunded' : 'Refund';

  return (
    <>
      {isEligibleForRefund && (
        <Button
          variant="contained"
          size="small"
          style={{ marginLeft: 8 }}
          onClick={handleRefundButtonClick}
          disabled={isRefunded}
        >
          {buttonText}
        </Button>
      )}
    </>
  );
}

export default RefundButton;
